import React from 'react';
import styles from './article.module.css';

import { CanvasContext } from './Article.context';

export const Canvas = ({
	paddingLeft,
	paddingRight,
	children,
	isAd = false,
}: CanvasProps) => {
	const classNames = [styles['canvas'], 'canvas'];
	const style: any = {};
	if (isAd) {
		style.maxHeight = `calc(${window.innerHeight}px - var(--top-bar-height))`;
		classNames.push(styles['ad']);
	} else {
		style.maxHeight = undefined;
	}

	return (
		<div className={classNames.join(' ')} style={style}>
			<div style={{ borderBottom: '1px solid transparent' }}>
				<CanvasContext.Provider
					value={{
						paddingLeft,
						paddingRight,
					}}
				>
					{children}
				</CanvasContext.Provider>
			</div>
		</div>
	);
};

interface CanvasProps {
	color?: string;
	backgroundColor?: string;
	isAd?: boolean;
	paddingLeft?: string | number | null | undefined;
	paddingRight?: string | number | null | undefined;
	paddingBottom?: string | number | null;
	paddingTop?: string | number | null;
	children?: React.ReactNode | Array<React.ReactNode>;
}
